const fechaLocalClave = (date = new Date()) => {
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10);
};

export const semanaIsoDeFecha = (fecha = "") => {
  const coincidencia = String(fecha).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!coincidencia) return "";

  const date = new Date(Date.UTC(
    Number(coincidencia[1]),
    Number(coincidencia[2]) - 1,
    Number(coincidencia[3]),
  ));
  const diaSemana = date.getUTCDay() || 7;
  date.setUTCDate(date.getUTCDate() + 4 - diaSemana);
  const inicioAnio = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  const semana = Math.ceil((((date - inicioAnio) / 86400000) + 1) / 7);
  return `${date.getUTCFullYear()}-W${String(semana).padStart(2, "0")}`;
};

export const crearFiltroFecha = () => {
  const dia = fechaLocalClave();
  return {
    tipo: "dia",
    dia,
    semana: semanaIsoDeFecha(dia),
    mes: dia.slice(0, 7),
    anio: dia.slice(0, 4),
    desde: dia,
    hasta: dia,
  };
};

export const coincideFiltroFecha = (fecha = "", filtro = {}) => {
  if (filtro.tipo === "todos") return true;
  if (!fecha) return false;
  if (filtro.tipo === "semana") return semanaIsoDeFecha(fecha) === filtro.semana;
  if (filtro.tipo === "mes") return fecha.slice(0, 7) === filtro.mes;
  if (filtro.tipo === "anio") return fecha.slice(0, 4) === String(filtro.anio || "");
  if (filtro.tipo === "rango") {
    return (!filtro.desde || fecha >= filtro.desde) && (!filtro.hasta || fecha <= filtro.hasta);
  }
  return fecha === filtro.dia;
};
